import config from 'util/config';
import { eventChannel } from 'redux-saga';
import { call, cancel, delay, fork, take, takeEvery } from 'redux-saga/effects';
import loadEntitiesSaga from './loadEntitiesSaga';
import { LOGOUT_ACTION_TYPES } from 'helpers/utilHelpers';

const isActiveTab = !(document.hidden || document.msHidden || document.mozHidden || document.webkitHidden);

let isLoadEntitiesUpdated = isActiveTab;

const entitiesUpdatedCheckIntervalMs = config.storage.entitiesUpdatedCheckIntervalMs;

function* intiLoadEntitiesInterval() {
  while (true) {
    yield delay(entitiesUpdatedCheckIntervalMs);
    if (isLoadEntitiesUpdated) {
      yield call(loadEntitiesSaga);
    }
  }
}

const disallowLoadEntitiesUpdated = () => (isLoadEntitiesUpdated = false);
const allowLoadEntitiesUpdated = () => (isLoadEntitiesUpdated = true);

function* handlerVisibilitychange() {
  if (document.visibilityState === 'hidden') {
    yield call(disallowLoadEntitiesUpdated);
    return;
  }

  // force load after visibility change
  yield call(loadEntitiesSaga);
  yield call(allowLoadEntitiesUpdated);
}

export default function* startCheckEntitiesUpdatedSaga() {
  const intervalTask = yield fork(intiLoadEntitiesInterval);

  const visibilitychangeChanel = eventChannel((emitter) => {
    document.addEventListener('visibilitychange', emitter);
    return () => document.removeEventListener('visibilitychange', emitter);
  });

  yield takeEvery(visibilitychangeChanel, handlerVisibilitychange);

  yield take(LOGOUT_ACTION_TYPES);
  yield cancel(intervalTask);
  visibilitychangeChanel.close();
}
